module.exports = __webpack_public_path__ + "static/media/calendar.220d2e49.svg";